<template>
    <div class="app_box">
        <el-form label-position="top" label-width="80px" :model="form" >
            <el-form-item label="联系地址">
                <el-input v-model="form.address" maxlength='50'></el-input>
            </el-form-item>
            <el-form-item label="联系电话">
                <el-input v-model="form.phone" maxlength='20'></el-input>
            </el-form-item>
            <el-form-item label="联系邮箱">
                <el-input v-model="form.email" maxlength='20'></el-input>
            </el-form-item>
            <el-form-item label="我们的优势">
                <el-input v-model="form.advantage" maxlength='50'></el-input>
            </el-form-item>
            <el-form-item label="网站名称">
                <el-input v-model="form.name" maxlength='20'></el-input>
            </el-form-item>
            <el-form-item label="网站域名">
                <el-input v-model="form.domain" maxlength='30'></el-input>
            </el-form-item>
            <el-form-item label="联系我们">
                <el-input v-model="form.contact" maxlength='50'></el-input>
            </el-form-item>
            <el-form-item label="Copyright">
                <el-input v-model="form.copyright" maxlength='50'></el-input>
            </el-form-item>
            <el-button @click="Save">保存设置</el-button>
        </el-form>
    </div>
</template>

<script>
    import {
        parameter,getParameter
    } from '../api/api'
    import local from '../utils/local'

    export default {
        data() {
            return {
                form: {
                    admin_id: local.get('admin_id'),
                    address: '',
                    email: '',
                    phone: '',
                    advantage: '',
                    name: '',
                    domain: '',
                    contact: '',
                    copyright: ""

                }
            }
        },
        methods: {
            Save() {
                parameter(this.form.admin_id,this.form.address,this.form.email,this.form.phone,this.form.advantage,this.form.name,this.form.domain,this.form.contact,this.form.copyright).then(res => {
                    if(res.data.status==200){
                        this.$message({
                            type:"success",
                            message:'保存成功'
                        })
                        this.getInfo()
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getInfo(){
                getParameter(this.form.admin_id).then(res=>{
                    if(res.data.status==200){
                    Object.assign(this.form,res.data.data[0])

                    }
                })
            }
        },
        created(){
            this.getInfo();
        }
    }
</script>

<style lang="less" scoped>
    .app_box {
        padding: 0 50px;

        .el-form-item {
            margin: 0;

            .el-form--label-top .el-form-item__label {
                padding: 0 !important;
            }

            .el-input {
                width: 800px;
            }

        }

        .el-button {
            margin-top: 20px;
        }
    }
</style>